__turbopack_context__.v({
  "boxed": "ProducerLocation-module-scss-module__nOkt8q__boxed",
  "energy": "ProducerLocation-module-scss-module__nOkt8q__energy",
  "location": "ProducerLocation-module-scss-module__nOkt8q__location",
  "wrapper": "ProducerLocation-module-scss-module__nOkt8q__wrapper",
});
